import { HTMLAttributes } from 'react'


export default function Badge<T extends HTMLAttributes<HTMLDivElement>>({children, ...props}:T) {
    return (
        <div
            {...props}
            className="badge"
        >
            {/* <img 
                src={imgSrc} 
                alt={alt} 
                style={{
                    width: "1vh"
                }}
            /> */}
            {children}
            
        </div>
    )
}
